import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  registrationContainer: {
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "575px",
    minHeight: "229px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
  },
  warning: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    border: '1px solid #CCCCCC',
    backgroundColor: '#CCCCCC',
    width: '100%',
    height: 'auto'
  },
  warningIcon: {
    color: '#CF7F00',
    marginLeft: '16px'
  },
  msg: {
    margin: '8px 16px 8px 16px',
  },
  form: {
    display: "flex",
    background: "#fff",
    flexDirection: "column",
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-input": {
      color: "#333",
      '&::placeholder': {
        color: '#666'
      }
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
      color: "#333",
      '&::placeholder': {
        color: '#666'
      }
    },
    "& h5": {
      padding: 0,
      marginBottom: "0.75rem",
      fontSize: "1rem",
      color: "#666",
    },
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    "& button": {
      padding: "0px 16px",
      width: "255.5px",
      height: "40px",

      cursor: "pointer",

      background: "#00843D",
      borderRadius: "2px",

      color: "white",
      border: 0,
      outline: 0,
    },
  },
  goBack: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    "& a": {
      color: "#00843D",
      fontWeight: 700,
      marginLeft: "5px",
    },
  },
  dividerText: {
    color: "#999999",
  },
  radioButtonIAm: {
    display: "flex",
  },
  typeClientContainer: {
    marginTop: "1.5rem",
    padding: "0 32px",
  },
  inputError: {
    "& .MuiOutlinedInput-root, & .Mui-focused": {
      color: "red",
      borderColor: "red",
    },
  },
  documentNumberContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1.5rem",
    gap: 24,
    padding: "0 32px",
  },
  selectBranches: {
    marginTop: "1.5rem",
    padding: "0 32px",
  },
  contactSupport: {
    margin: 10,
    "& .MuiTypography-body1": {
      fontSize: "12px",
      color: "#666",
    },
    "& span": {
      color: "#007582",
      fontWeight: 700,
    },
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#fff",
    fontSize: "14px",
    padding: "24px 32px",
    marginTop: "1rem",
    borderTop: "1px solid #ccc",
    "& .goNext": {
      display: "flex",
      alignItems: "center",
      fontSize: "10px",
      color: "#666666",
      fontWeight: 700,
      gap: "10px",
    },
    "& .goBack": {
      border: "2px solid #26975A",
      color: "#26975A",
      height: "32px",
      "& svg": {
        fontSize: "14px",
      },
    },
    "& .MuiButton-label": {
      fontSize: "14px",
    },
    "& .next": {
      background: "#26975A",
      color: "#FFF",
      height: "32px",
    },
    "& .Mui-disabled": {
      background: "#EEE",
      color: "#999",
    },
  },
}));

export default useStyles;
